import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChatService } from '../../../services/chat.service';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-candidat-layout',
  templateUrl: './candidat-layout.component.html',
  styleUrl: './candidat-layout.component.scss'
})
export class CandidatLayoutComponent implements OnInit, OnDestroy {

  isChatOpen = false;
  isChatActive = true; // Control whether chat feature is visible
  totalUnreadCount = 0;
  private unreadCountSubscription: Subscription | null = null;
  private unreadRefreshInterval: any;
  private chatOpenSubscription: Subscription | null = null;
  private chatActiveSubscription: Subscription | null = null;

  constructor(
    private chatService: ChatService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Subscribe to chat active status changes
    this.chatActiveSubscription = this.chatService.chatActive$.subscribe((isActive: boolean) => {
      this.isChatActive = isActive;
    });

    // Load initial chat active status
    this.isChatActive = this.chatService.isChatActive;

    // Load initial unread count
    this.loadTotalUnreadCount();

    // Subscribe to unread count updates from WebSocket
    this.unreadCountSubscription = this.chatService.unreadCount$.subscribe(() => {
      // Only reload if chat is NOT open
      if (!this.isChatOpen) {
        this.loadTotalUnreadCount();
      }
    });

    // Subscribe to chat open/close events
    this.chatOpenSubscription = this.chatService.chatOpen$.subscribe((isOpen: boolean) => {
      this.isChatOpen = isOpen;
      if (isOpen) {
        // When chat opens, immediately reset counter to 0
        this.totalUnreadCount = 0;
      } else {
        // When chat closes, reload the count
        this.loadTotalUnreadCount();
      }
    });

    // Refresh unread count every 10 seconds (only if chat is closed)
    this.unreadRefreshInterval = setInterval(() => {
      if (!this.isChatOpen) {
        this.loadTotalUnreadCount();
      }
    }, 5000);
  }

  ngOnDestroy(): void {
    if (this.unreadCountSubscription) {
      this.unreadCountSubscription.unsubscribe();
    }
    if (this.chatOpenSubscription) {
      this.chatOpenSubscription.unsubscribe();
    }
    if (this.chatActiveSubscription) {
      this.chatActiveSubscription.unsubscribe();
    }
    if (this.unreadRefreshInterval) {
      clearInterval(this.unreadRefreshInterval);
    }
  }

  loadTotalUnreadCount(): void {
    const user = this.authService.user;
    if (user && user.collary_id && this.isChatActive) {
      this.chatService.getTotalUnreadCount(user.collary_id, 'CANDIDAT').subscribe({
        next: (count) => {
          this.totalUnreadCount = count;
        },
        error: (error) => {
          console.error('Error loading unread count:', error);
        }
      });
    }
  }

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
  }
}
